module.exports = __webpack_public_path__ + "assets/img/vip.49f73b2e.svg";